export const getters = {
    appTitle(state) {
        return state.appName
    },
    getUser(state) {
        if (state.user != null) {
            return state.user
        }
        state.user = JSON.parse(localStorage.getItem("UserInfo"))
        return state.user
    },
    getError(state) {
        return state.error
    },
    getLoading(state) {
        return state.loading
    },
    getAccessToken(state) {
        if (state.access_token != null) {
            return state.access_token
        }
        state.access_token = localStorage.getItem("AccessToken")
        return state.access_token
    },
    getLineId(state) {
        return state.lineId
    },
    isAuth(state) {
        if (state.user) {
            return state.user.uId !== null;
        }
        return true
    },
}